import { toggleModal, ADD_EMPLOYEE_TO_LIST, UPDATE_EMPLOYEE_IN_LIST,UPDATE_ADMIN_IN_LIST, 
    DELETE_EMPLOYEE_FROM_LIST,DEACTIVATE_EMPLOYEE_FROM_LIST,ACTIVATE_EMPLOYEE_FROM_LIST, ADD_EMPLOYEES_TO_LIST } from './mutation-types';

export default {
    [toggleModal]: (state, value) => {
        state.isShowAddOrUpdateModal = value;
    },

    [ADD_EMPLOYEES_TO_LIST]: (state, employeesList) => {
        employeesList.forEach((employee) => {
            employee.fname = `${employee.fname}`;
            employee.lname = `${employee.lname}`;
            employee.name = `${employee.fname} ${employee.lname}`;
            employee.role = employee.group;
            // delete employee.fname;
            // delete employee.lname;
            delete employee.group;
        });
        state.employeesList = employeesList;
    },

    [ADD_EMPLOYEE_TO_LIST]: (state, employee) => {
        employee.name = `${employee.fname} ${employee.lname}`;
        employee.role = employee.group;

        delete employee.fname;
        delete employee.lname;
        delete employee.group;

        state.employeesList.push(employee);
    },

    [UPDATE_EMPLOYEE_IN_LIST]: (state, updatedEmployee) => {
        const index = state.employeesList.findIndex((employee) => employee.id === updatedEmployee.id);
        state.employeesList[index] = updatedEmployee;
    },
     [UPDATE_ADMIN_IN_LIST]: (state, updatedAdmin) => {
        const index = state.employeesList.findIndex((employee) => employee.id === updatedAdmin.id);
        state.employeesList[index] = updatedAdmin;
    },

    [DELETE_EMPLOYEE_FROM_LIST]: (state, employeeIDs) => {
        state.employeesList.forEach((element, index) => {
            employeeIDs.forEach((id) => {
                if (id == element.id || id === element.id) {
                    state.employeesList.splice(index, 1);
                }
            });
        });
    },
    [DEACTIVATE_EMPLOYEE_FROM_LIST]: (state, employeeIDs) => {
        state.employeesList.forEach((element, index) => {
            employeeIDs.forEach((id) => {
                if (id == element.id || id === element.id) {
                    state.employeesList.splice(index, 1);
                }
            });
        });
    },
    [ACTIVATE_EMPLOYEE_FROM_LIST]: (state, employeeIDs) => {
        state.employeesList.forEach((element, index) => {
            employeeIDs.forEach((id) => {
                if (id == element.id || id === element.id) {
                    state.employeesList.splice(index, 1);
                }
            });
        });
    },
};